import React from "react";
import { useCheckoutContext } from "../CheckoutContext";
import { getPromoAppliedMessage } from "./checkoutPromoLabels";

export const CheckoutPaymentMobileRecap: React.FC = () => {
  const { packageInfo, state, getFinalPrice, formatCurrency, formatPercentage } =
    useCheckoutContext();

  if (!packageInfo) return null;

  const promoLine =
    state.promoCode.applied && state.promoCode.code
      ? getPromoAppliedMessage(state.promoCode, { formatCurrency, formatPercentage })
      : null;

  return (
    <div className="space-y-3 rounded-xl border border bg-background p-4 shadow-sm lg:hidden">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs font-medium text-text-secondary">Seu pacote</p>
          <p className="truncate font-semibold text-foreground">{packageInfo.name}</p>
          {promoLine ? (
            <p className="mt-1 text-xs text-success-subtle">
              Cupom <span className="font-mono">{state.promoCode.code}</span> — {promoLine}
            </p>
          ) : null}
        </div>
        <p className="shrink-0 text-lg font-bold text-success-subtle">{formatCurrency(getFinalPrice())}</p>
      </div>
      {state.paymentError ? (
        <p className="text-sm text-red-600" role="alert">
          {state.paymentError}
        </p>
      ) : null}
      {state.promoCode.error ? (
        <p className="text-sm text-red-600" role="alert">
          {state.promoCode.error}
        </p>
      ) : null}
    </div>
  );
};
